<template>
  <input-text v-bind="$attrs" v-model="model" v-on="$listeners" placeholder=" " :type="showPassword ? 'text' : 'password'" allow-special-chars
    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :upper-case="false"
    @click:append="showPassword = !showPassword">
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]="context">
      <slot :name="slotName" v-bind="context" />
    </template>
    <template v-for="(_, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
  </input-text>
</template>

<script>
export default {
  props: {
    value: null,
  },
  data () {
    return {
      showPassword: false
    }
  },
  computed: {
    model: {
      get () {
        return this.value;
      },
      set (value) {
        this.$emit('input', value)
      },
    },
  }
}
</script>
